<template>
    <hts-router-drawer
        ref="routerDrawer"
        :title="$t('labels.quoteRequestEdit')"
        :size="80"
        :submit="submit"
        :rules="dataRule"
        :page-tabs="pageTabs?.quote || []"
        @loaded="getData">
        <div :style="{ minWidth: minWidthScroll }">
            <div class="font-bold my-3 ml-3 flex space-x-1 items-center">
                <div v-if="cListStatus.length">
                    <span>
                        {{ $t('labels.status') }}:
                    </span>
                    <div class="flex items-center gap-2">
                        <status-component
                            size="large"
                            module="quoteRequest"
                            :status="dataEditQuotRequest.status || 0" />
                        <hts-dropdown
                            trigger="click"
                            class="w-52"
                            :options="cListStatus"
                            label-key="label"
                            :placement="'bottom'"
                            :offset="[0, 15]"
                            @click="handelEditStatus">
                            <template #default="{ item }">
                                <div class="w-52">
                                    <status-component
                                        size="large"
                                        module="quoteRequest"
                                        :status="item.value" />
                                </div>
                            </template>
                            <template #reference>
                                <div class="flex items-center cursor-pointer">
                                    <hi-pencil-square-icon class="h-5 w-5 text-blue-600 hover:text-blue-500" />
                                </div>
                            </template>
                        </hts-dropdown>
                    </div>
                </div>
                <status-component
                    v-else
                    size="large"
                    module="quoteRequest"
                    :status="dataEditQuotRequest.status || 0" />
            </div>
            <hts-card :title="$t('labels.customer')">
                <div class="grid gap-x-2 grid-cols-4">
                    <hts-select-cooperator
                        v-model="dataEditQuotRequest.customer"
                        v-model:name="dataEditQuotRequest.customerName"
                        :label="$t('labels.customer')"
                        type-cooperator="CUSTOMER"
                        :creatable="true"
                        required
                        disabled
                        prop="customer"
                        name-select="customer"
                        @change="selectCustomer" />
                    <hts-select-cooperator-contact
                        v-model="dataEditQuotRequest.contact"
                        v-model:name="dataEditQuotRequest.contactName"
                        :disabled="!dataEditQuotRequest.customer"
                        :cooperator-id="dataEditQuotRequest.customer"
                        :label="$t('labels.contact')"
                        :creatable="true"
                        required
                        prop="contact"
                        name-select="contact"
                        :param-prepare="dataEditQuotRequest.customer"
                        @change="selectContact" />
                    <hts-form-input
                        v-model="dataContact.email"
                        :label="$t('labels.email')"
                        disabled />
                    <hts-form-input
                        v-model="dataContact.phone"
                        :label="$t('labels.phone')"
                        disabled />
                </div>
            </hts-card>
            <hts-card :title="$t('labels.shippingInformation')">
                <div class="grid gap-x-2 grid-cols-2">
                    <hts-select-cooperator-business-opportunity
                        v-model="dataEditQuotRequest.businessOpportunity"
                        v-model:name="dataEditQuotRequest.businessOpportunityName"
                        :label="$t('labels.businessOpportunity')"
                        :creatable="true"
                        disabled
                        :cooperator-id="dataEditQuotRequest.customer"
                        required
                        prop="businessOpportunity"
                        name-select="businessOpportunity"
                        key-label="nameCustom1"
                        key-sub-label="nameCustom2"
                        :param-prepare="dataEditQuotRequest.customer"
                        @change="selectCooperatorBusinessOpportunity" />

                    <hts-select-commodity-opportunity
                        v-model="dataEditQuotRequest.commodity"
                        v-model:name="dataEditQuotRequest.commodityName"
                        :label="$t('labels.commodity')"
                        :creatable="true"
                        :disabled="!dataEditQuotRequest.customer || !dataEditQuotRequest.businessOpportunity"
                        :cooperator-id="dataEditQuotRequest.customer"
                        :opportunity-id="dataEditQuotRequest.businessOpportunity"
                        required
                        prop="commodityBusinessOpportunity"
                        name-select="commodityBusinessOpportunity"
                        :param-prepare="dataEditQuotRequest.businessOpportunity" />
                </div>
                <hts-form-input
                    v-model="dataEditQuotRequest.workflowName"
                    :label="$t('labels.workflow')"
                    disabled
                    required />
                <ul
                    v-if="dataEditQuotRequest.positions && dataEditQuotRequest.positions.length"
                    class="steps steps-vertical w-full">
                    <li
                        v-for="(item, index) in dataEditQuotRequest.positions"
                        :key="index"
                        data-content=" "
                        class="pl-10 step w-full">
                        <div class="flex items-center justify-center w-full">
                            <span class="w-52 flex justify-start">
                                {{ item.nodeTypeName }}
                            </span>
                            <div class="flex items-center w-full gap-5">
                                <hts-form-input
                                    v-model="item.fullNameNode"
                                    class="w-full"
                                    readonly />

                                <hts-form-button
                                    icon-name="hi-pencil-square-icon"
                                    size="small"
                                    class="w-96"
                                    color="info"
                                    @click="() => openWorkflowPosition(item)">
                                    {{ $t('labels.editCompletionTime') }}
                                </hts-form-button>
                            </div>
                        </div>
                    </li>
                </ul>

                <hts-form-button
                    v-if="dataEditQuotRequest.positions && dataEditQuotRequest.positions.length"
                    icon-name="hi-plus-circle-icon"
                    class="text-right mt-5 w-48"
                    color="info"
                    :btn-outline="false"
                    type="button"
                    @click="handleFindRoutingConnection">
                    {{ $t('labels.selectTheLeftLane') }}
                </hts-form-button>

                <div>
                    <div v-if="dataEditQuotRequest.transportation === 'CONTAINER'">
                        <hts-form-input
                            v-model="dataEditQuotRequest.contName"
                            :label="$t('labels.cont')"
                            disabled
                            required />
                        <span class="mt-2">
                            {{ $t('labels.requestSpecial') }}
                        </span>
                        <div class="flex">
                            <hts-form-checkbox
                                v-if="dataEditQuotRequest.contCategory === 20"
                                v-model="dataEditQuotRequest.mergeContainer"
                                color="secondary"
                                :items="[{ label: $t('labels.mergeContainer'), value: false }]" />
                            <hts-form-checkbox
                                v-model="dataEditQuotRequest.headContainer"
                                color="secondary"
                                :items="[{ label: $t('labels.headContainer'), value: false }]" />
                        </div>
                    </div>
                    <div v-else-if="dataEditQuotRequest.transportation === 'NON_CONTAINER'">
                        <hts-form-input
                            v-model="dataEditQuotRequest.vehicleCategoryName"
                            :label="$t('labels.vehicleType')"
                            disabled
                            required />
                    </div>
                    <hts-form-input
                        v-model="dataEditQuotRequest.productivity"
                        :label="$t('labels.productivityByMount')"
                        type="number"
                        required
                        prop="productivity"
                        name="productivity">
                        <template #suffix>
                            <span>
                                {{ dataEditQuotRequest.transportation ? (dataEditQuotRequest.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                            </span>
                        </template>
                    </hts-form-input>
                    <hts-form-input
                        v-model="dataEditQuotRequest.weightCommodity"
                        :label="$t('labels.weightCommodityByKG1')"
                        type="number"
                        required
                        prop="weightCommodityByKG"
                        name="weightCommodityByKG1">
                        <template #suffix>
                            <span>
                                {{
                                    dataEditQuotRequest.transportation ? `/${dataEditQuotRequest.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')}` : '-'
                                }}
                            </span>
                        </template>
                    </hts-form-input>
                    <hts-form-textarea
                        v-model="dataEditQuotRequest.request"
                        :label="$t('labels.requestOther')" />
                </div>
            </hts-card>
        </div>
        <workflow-position
            ref="workflowPosition"
            @update="updatePosition" />
        <hts-modal
            :show="openPopupEditStatus"
            :title="$t('labels.editStatusQuote')"
            type="confirm"
            :content="$t('labels.confirmEditStatusQuote')"
            @hide="openPopupEditStatus = false"
            @confirm="handelEditStatus" />

        <routing-connection
            ref="routingConnection"
            @update="updateRoutingConnections" />
    </hts-router-drawer>
</template>

<script lang="ts" setup>
import RoutingConnection from '../-components/routing-connection.vue'
import WorkflowPosition from '../-components/workflow-position.vue'
import StatusComponent from '@/pages/trucker-[id]/statistics/-components/status.vue'
import pageTabs from '~/data/page-tabs/trucker.json'
import listStatus from '~/fucntion/quote-request/status'
import { IWorkflowPosition } from '~/pages/admincp/workflow/ignore/imports/form'
import { IQuoteRequest } from '~/pages/trucker-[id]/quote/quote-request/-components/ignore/imports/form'

import { $api, $lodash } from '#imports'

import screen from '~/components/utils/screen'

const { $disableReactive } = useNuxtApp()
const route = useRoute()
const quoteRequestId = computed(() => useRoute().params.idquoterequest)
const store = $store()
const routerDrawer = ref()
const loadingEditStatus = ref(false)
const emits = defineEmits(['refreshTables'])
const routingConnection = ref()
const routingConnectionsData = ref<{ [key: string]: any }[][]>([])

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm + 100}px`
})

const dataContact = ref<{ [key: string]: any }>({})
const selectContact = (item: { [key: string]: any }) => {
  if (!Array.isArray(item) || !item.length) {
    dataContact.value.email = ''
    dataContact.value.phone = ''
    return
  }

  dataContact.value = item[0]
  dataEditQuotRequest.value.contactName = item[0]?.fullName
}

const selectCustomer = (item: { [key: string]: any }) => {
  if (!Array.isArray(item) || !item.length) {
    resetFields()
    return
  }

  resetFields()
  dataEditQuotRequest.value.customer = item[0]._id
  dataEditQuotRequest.value.customerName = item[0].name
}

const loadingSelectCooperator = ref(false)
const status = ref(-1)

const dataCooperatorBusinessOpportunity = ref<{ [key: string]: any }>({})
const selectCooperatorBusinessOpportunity = async (item: { [key: string]: any }) => {
  loadingSelectCooperator.value = true
  dataCooperatorBusinessOpportunity.value = Array.isArray(item) && item.length && item[0]
  dataEditQuotRequest.value.commodity = ''
  dataEditQuotRequest.value.commodityName = ''
  dataEditQuotRequest.value.routingConnections = undefined
  dataEditQuotRequest.value.connectingPositions = undefined
  routingConnectionsData.value = []
  await setFormData()
}

const setFormData = async () => {
  dataEditQuotRequest.value.productivity = dataCooperatorBusinessOpportunity.value.productivity || null
  dataEditQuotRequest.value.weightCommodity = dataCooperatorBusinessOpportunity.value.weightCommodity || null
  dataEditQuotRequest.value.transportation = dataCooperatorBusinessOpportunity.value.transportation || ''
  if (dataEditQuotRequest.value.transportation && dataEditQuotRequest.value.transportation === 'CONTAINER') {
    dataCooperatorBusinessOpportunity.value.contName = listLabelCont[dataCooperatorBusinessOpportunity.value.contCategory] ?? ''
  } else if (dataEditQuotRequest.value.transportation && dataEditQuotRequest.value.transportation === 'NON_CONTAINER') {
    dataCooperatorBusinessOpportunity.value.vehicleCategoryName = dataCooperatorBusinessOpportunity.value.vehicleCategoryDetail?.name ?? ''
  }
  dataEditQuotRequest.value.workflow = dataCooperatorBusinessOpportunity.value.workflow
  dataEditQuotRequest.value.contCategory = dataCooperatorBusinessOpportunity.value.contCategory
  dataEditQuotRequest.value.vehicleCategory = dataCooperatorBusinessOpportunity.value.vehicleCategory
  dataEditQuotRequest.value.headContainer = false
  dataEditQuotRequest.value.mergeContainer = false
  dataEditQuotRequest.value.workflowName = dataCooperatorBusinessOpportunity.value.workflowName
  dataEditQuotRequest.value.positions = dataCooperatorBusinessOpportunity.value.positions || []
  dataEditQuotRequest.value.contName = dataCooperatorBusinessOpportunity.value.contName || []
  dataEditQuotRequest.value.vehicleCategoryName = dataCooperatorBusinessOpportunity.value.vehicleCategoryName || ''
  await setDataPosition()
}

const setDataPosition = async () => {
  try {
    const api = $urlPartner.quote.quoteRequest.viewTimeComplete
    if (dataEditQuotRequest.value.businessOpportunity) {
      const data: any = await $api(api, { uriParams: { IDBUSINESSOPPORTUNITY: dataEditQuotRequest.value.businessOpportunity } })
      const resData = data?.data?.value
      if (resData && resData.success) {
        dataEditQuotRequest.value.positions = resData.data
        loadingSelectCooperator.value = false
      }
    }
    loadingSelectCooperator.value = false
  } catch (e) {
    loadingSelectCooperator.value = false
  }
}

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}

const dataEditQuotRequest = ref<IQuoteRequest>({
  customer: '',
  customerName: '',
  commodity: '',
  commodityName: '',
  contact: '',
  businessOpportunity: '',
  businessOpportunityName: '',
  workflow: '',
  workflowData: [],
  productivity: null,
  weightCommodity: null,
  tasks: [
    {
      code: '',
      value: null
    }
  ],
  request: '',
  requestSpecial: '',
  transportation: '',
  contactName: '',
  mergeContainer: false,
  headContainer: false,
  contCategory: null,
  vehicleCategory: '',
  workflowName: '',
  positions: [],
  contName: '',
  vehicleCategoryName: '',
  status: -1,
  routingConnections: undefined,
  connectingPositions: undefined
})

const resetFields = () => {
  dataEditQuotRequest.value = {
    customer: '',
    customerName: '',
    commodity: '',
    commodityName: '',
    contact: '',
    businessOpportunity: '',
    businessOpportunityName: '',
    workflow: '',
    workflowData: [],
    productivity: null,
    weightCommodity: null,
    tasks: [
      {
        code: '',
        value: null
      }
    ],
    request: '',
    requestSpecial: '',
    transportation: '',
    contactName: '',
    mergeContainer: false,
    headContainer: false,
    contCategory: null,
    vehicleCategory: '',
    workflowName: '',
    positions: [],
    contName: '',
    vehicleCategoryName: '',
    status: -1,
    routingConnections: undefined,
    connectingPositions: undefined
  } as IQuoteRequest
  dataContact.value = { email: '', phone: '' }
  routingConnectionsData.value = []
}

onBeforeMount(() => {
  route.meta.pageTabs = pageTabs?.quote || []
})

const getData = () => {
  const api = $urlPartner.quote.quoteRequest.getDetail
  $api(api, { uriParams: { ID: quoteRequestId.value } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        Object.assign(dataEditQuotRequest.value, { ...resData.data })
        Object.assign(dataContact.value, { ...resData.data?.contactDetail })
        if (dataEditQuotRequest.value.contCategory) {
          dataEditQuotRequest.value.contName = listLabelCont[dataEditQuotRequest.value.contCategory] ?? ''
        }
        status.value = Number($lodash.cloneDeep(dataEditQuotRequest.value.status))
        routingConnectionsData.value = $lodash.cloneDeep(resData.data.routingConnections)
        if (dataEditQuotRequest.value.routingConnections) {
          dataEditQuotRequest.value.routingConnections = dataEditQuotRequest.value.routingConnections.map((item: any) => {
            const pluckIdData = $lodash.map(item, 'node')
            const nodeIds = $lodash.join(pluckIdData, '-')
            return nodeIds
          })
        }
      }
    })
    .catch(() => {})
}

const workflowPosition = ref()
const openWorkflowPosition = (position: IWorkflowPosition) => {
  if (workflowPosition.value) {
    workflowPosition.value.open($disableReactive(position), dataEditQuotRequest.value, false)
  }
}

const submit = async () => {
  const api = $urlPartner.quote.quoteRequest.edit
  const data: any = await $api(api, { body: dataEditQuotRequest.value, uriParams: { ID: quoteRequestId.value } })
  const resData = data?.data?.value
  if (resData && resData.success) {
    if (resData.success) {
      process.client && $toast().success($t('labels.editQuoteRequestSuccess'))
      close()
      resetFields()
      emits('refreshTables')
      routerDrawer.value.handleSubmitClose()
    }
  }
}

const defineRule: { [key: string]: any } = {}

const configCont: { [key: string]: any } = computed(() => store.globalSettings.getGlobalSettings.configCont)

const configVehicle: { [key: string]: any } = computed(() => {
  return store.data.getVehicleCategories
})

const dataRule = computed(() => {
  const result: { [key: string]: any } = { ...{}, ...defineRule }
  if (dataEditQuotRequest.value.transportation === 'CONTAINER' && dataEditQuotRequest.value.contCategory) {
    if (configCont.value && configCont.value[dataEditQuotRequest.value.contCategory] && configCont.value[dataEditQuotRequest.value.contCategory].weightCargo) {
      result.weightCommodityByKG = `required|validationCustom:
      ${
        dataEditQuotRequest.value.weightCommodity &&
        dataEditQuotRequest.value.weightCommodity <= configCont.value[dataEditQuotRequest.value.contCategory].weightCargo
      }--
      ${$t('labels.checkWeightContainer')} - ${configCont.value[dataEditQuotRequest.value.contCategory].weightCargo}`
    }
  } else if (dataEditQuotRequest.value.transportation === 'NON_CONTAINER' && dataEditQuotRequest.value.vehicleCategory && configVehicle.value) {
    const findVehicleCategory = configVehicle.value.find((findVehicleCategory: { [key: string]: any }) => {
      return findVehicleCategory._id === dataEditQuotRequest.value.vehicleCategory
    })
    if (findVehicleCategory) {
      const min = Number(findVehicleCategory.from || 0)
      const max = Number(findVehicleCategory.to || 999999999999999)
      result.weightCommodityByKG = `required|validationCustom:
      ${dataEditQuotRequest.value.weightCommodity && min <= dataEditQuotRequest.value.weightCommodity && dataEditQuotRequest.value.weightCommodity < max}--
      ${$t('labels.checkWeightVehicle')} (${min} <= ${$t('labels.weightCommodity')} < ${max})`
    }
  }
  return result
})

const updatePosition = (data: { [key: string]: any }) => {
  if (data && typeof data === 'object' && dataEditQuotRequest.value.positions) {
    const findIndexPosition = dataEditQuotRequest.value.positions.findIndex((item: { [key: string]: any }) => {
      return item.index === data.index
    })
    if (findIndexPosition !== -1 && dataEditQuotRequest.value.positions) {
      dataEditQuotRequest.value.positions[findIndexPosition] = data
    }
  }
}

const cListStatus = computed(() => {
  const result: Array<{ label: string; value: number }> = []
  listStatus().forEach((item: { label: string; value: number }) => {
    if (status.value === 0 && [3, 0].includes(item.value)) {
      result.push(item)
    }
    if (status.value === 1 && [3, 1].includes(item.value) && !dataEditQuotRequest.value.isHaveBeanCreated) {
      result.push(item)
    }
    if (status.value === 3 && [0, 3].includes(item.value)) {
      result.push(item)
    }
  })
  return $lodash.sortBy(result, [
    (item: { label: string; value: number }) => {
      if (item.value === status.value) {
        return true
      }
    }
  ])
})

const openPopupEditStatus = ref(false)
const statusEdit = ref(0)

const handleOpenPopupEditStatus = (item: { label: string; value: number }) => {
  statusEdit.value = item.value
  openPopupEditStatus.value = true
}

const handelEditStatus = (item: { label: string; value: number }) => {
  dataEditQuotRequest.value.status = item.value
}

const handleFindRoutingConnection = () => {
  if (routingConnection?.value) {
    routingConnection.value.open(
      dataEditQuotRequest.value.positions || [],
      dataEditQuotRequest.value.routingConnections,
      dataEditQuotRequest.value.connectingPositions || []
    )
  }
}
const updateRoutingConnections = (data: { [key: string]: any }) => {
  dataEditQuotRequest.value.routingConnections = data.routingConnections
  dataEditQuotRequest.value.connectingPositions = data.connectingPositions
  routingConnectionsData.value = data.routingConnectionsData
}
</script>
~/fucntion/quote-request/status
